jQuery(function ($) {

  activateSlider()

  function activateSlider() {

    const swiper = new Swiper('.swiper-container', {

      direction: 'horizontal',
      slidesPerView: 5,
      spaceBetween: 30,
      
      breakpoints: {
        1440: {
          slidesPerView: 5
        },
        1280: {
          slidesPerView: 4
        },
        768: {
          slidesPerView: 3
        },
        767: {
          enabled: false
        }
      },

      pagination: {
        el: '.swiper-pagination',
        clickable: true
      },

      navigation: {
        nextEl: '.swiper-button-next-custom',
        prevEl: '.swiper-button-prev-custom'
      },

    });

    enableSlider();
    
    $(window).on('resize', function() {
      enableSlider();
    })

    function enableSlider() {
   
      if(swiper.params.slidesPerView >= swiper.slides.length) {
        swiper.disable();
      } else {
        swiper.enable();
      }
     
    }

  }

});
